import { defineStore } from 'pinia';

export const useProformaRequestStore = defineStore('proformaRequestStore', () => {
    var proformaRequestModal = ref<boolean>(false);
    var subProgrammeId = ref<string>("");
    var subProgrammeName = ref<string>("");

    const getProformaRequestModal = computed(() => proformaRequestModal.value);

    function isOpenProformaRequestModal() {
        proformaRequestModal.value = true;
    }

    function isClosedProformaRequestModal() {
        proformaRequestModal.value = false;
    }

    function setSubProgrammeId(id: string) {
        subProgrammeId.value = id;
    }

    function setSubProgrammeName(name: string) {
        subProgrammeName.value = name;
    }

    const getSubProgrammeId = computed(() => subProgrammeId.value);
    const getSubProgrammeName = computed(() => subProgrammeName.value);

    return {
        getProformaRequestModal,
        isOpenProformaRequestModal,
        isClosedProformaRequestModal,
        setSubProgrammeId,
        setSubProgrammeName,
        getSubProgrammeId,
        getSubProgrammeName
    };
});
